"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("../Styles/DashboardPanel.css");
var react_router_dom_1 = require("react-router-dom");
var Components_1 = require("../Components");
var DashboardPanel = /** @class */ (function (_super) {
    __extends(DashboardPanel, _super);
    function DashboardPanel(props) {
        return _super.call(this, props) || this;
    }
    DashboardPanel.prototype.render = function () {
        return (React.createElement("div", { className: "dashboard-panel" },
            React.createElement("div", { className: "dashboard-panel-item actions-panel" },
                React.createElement("h5", { className: "text-primary text-uppercase" }, this.props.applicationData.resources.Action),
                this.props.actions || React.createElement("p", { className: "text-muted font-italic" }, this.props.placeholder)),
            React.createElement("div", { className: "dashboard-panel-item status-panel" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col" },
                        React.createElement(react_router_dom_1.Link, { to: "/Dashboard/Multiple/Queue" }, this.props.applicationData.resources.MultipleRecordsQueued)),
                    React.createElement("div", { className: "col-md-auto" }, this.props.applicationData.multipleQueueCount)),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col" },
                        React.createElement(react_router_dom_1.Link, { to: "/Dashboard/DeferredQueue" }, this.props.applicationData.resources.RecordsQueued)),
                    React.createElement("div", { className: "col-md-auto" }, this.props.applicationData.deferredQueueCount))),
            React.createElement("div", { className: "dashboard-panel-item status-panel" },
                React.createElement(Components_1.OfflineTemplatePanel, { applicationData: this.props.applicationData })),
            React.createElement("div", { className: "dashboard-panel-item status-panel" },
                React.createElement(Components_1.ConnectionStatePanel, { applicationData: this.props.applicationData }))));
    };
    return DashboardPanel;
}(React.Component));
exports.DashboardPanel = DashboardPanel;
//# sourceMappingURL=DashboardPanel.js.map